export default {
  'acc103.action.SAVE': '儲存',
  'acc103.action.ATTACH': '補充附件',
  'acc103.action.VOID': '作廢',
  'acc103.status.CONFIRMED': '已計入',
  'acc103.title': '費用發票管理',
  'acc103.month': '憑證月份',
  'acc103.merchant': '商家',
  'acc103.receiptDate': '憑證日期',
  'acc103.receiptNumber': '憑證號碼',
  'acc103.currency': '原幣幣種',
  'acc103.grossAmount': '原幣含稅金額',
  'acc103.taxAmount': '原幣稅額',
  'acc103.remarks': '備註',
  'acc103.duplicateReason': '重複新建原因',
  'acc103.linkMode': '關聯方式',
  'acc103.sourceMonth': '支出／預算所屬月份',
  'acc103.cashEntryId': '既有手動支出',
  'acc103.fixedCode': '固定費用',
  'acc103.paidDate': '實際付款日期',
  'acc103.paidJpy': '日圓實付金額',
  'acc103.status': '登記狀態',
  'acc103.actions': '操作',
  'acc103.reload': '重新載入',
  'acc103.new': '新增憑證',
  'acc103.edit': '編輯',
  'acc103.view': '檢視',
  'acc103.void': '作廢',
  'acc103.close': '關閉',
  'acc103.history': '變更歷史',
  'acc103.actor': '操作人',
  'acc103.saveDraft': '儲存草稿',
  'acc103.saveLink': '儲存並關聯',
  'acc103.saved': '儲存成功',
  'acc103.openOriginal': '開啟原登記組',
  'acc103.camera': '拍照',
  'acc103.upload': '相簿／檔案',
  'acc103.fileHint':
    'JPEG / PNG / WebP / PDF，單檔最多10MB、PDF最多10頁。一組一份憑證，補件不重複計入支出。',
  'acc103.preview': '原件預覽',
  'acc103.previewFailed': '讀取失敗，請重新選擇附件重試。',
  'acc103.noFile': '選擇或上傳原件',
  'acc103.aiNotice': '選取的原件將傳送至MiniMax中國站。結果須人工核對，不會自動入帳。是否繼續？',
  'acc103.aiDisabled': 'AI尚未設定或未通過實際圖片驗收。仍可手動填寫、儲存草稿及關聯。',
  'acc103.recognize': 'AI辨識／重試',
  'acc103.pages': '已處理頁數',
  'acc103.applyWarning': '套用辨識欄位？請核對金額、日期及多稅率資訊。',
  'acc103.apply': '套用辨識結果',
  'acc103.stale': '草稿或表單已變更，請儲存後重新辨識，避免覆蓋人工內容。',
  'acc103.currencyHint': '請輸入三位大寫幣種代碼，例如JPY、USD。',
  'acc103.duplicateHint': '重複時請關聯原組；確需新建時說明原因。',
  'acc103.link': '支出關聯',
  'acc103.budget': '既有預算',
  'acc103.difference': '實際憑證與預算差額',
  'acc103.budgetHint': '僅關聯憑證及顯示差額，不取代預算、不增加支出。',
  'acc103.syncPayment': '同步原支出的實際日期和金額（影響損益及現金預測）',
  'acc103.linkedPayment': '關聯支出的目前狀態',
  'acc103.paymentHint':
    '新增費用需填實際付款日期和日圓實付金額。不完整時儲存草稿；原幣稅額僅作憑證資訊。',
  'acc103.voidWarning': '僅作廢憑證，原支出和付款不變。是否繼續？',
  'acc103.mode.NEW': '新增費用',
  'acc103.mode.EXISTING': '關聯既有手動支出',
  'acc103.mode.FIXED': '關聯固定費用',
  'acc103.status.DRAFT': '草稿',
  'acc103.status.REGISTERED': '已登記',
  'acc103.status.VOID': '已作廢',
  'acc103.status.QUEUED': '排隊中',
  'acc103.status.RUNNING': '辨識中',
  'acc103.status.SUCCEEDED': '辨識完成',
  'acc103.status.FAILED': '辨識失敗',
  'acc103.error.FAILED': '操作失敗，輸入已保留，請核對後重試。',
  'acc103.error.INVALID': '請檢查輸入、日期及金額格式。',
  'acc103.error.CONFLICT': '記錄已變更，請重新開啟核對。',
  'acc103.error.DUPLICATE': '發現重複檔案或疑似重複憑證，請開啟原組或填寫新建原因。',
  'acc103.error.NOT_FOUND': '記錄不存在或無法存取。',
  'acc103.error.REGISTER_REQUIRED': '已登記憑證請使用儲存並關聯。',
  'acc103.error.PAYMENT_REQUIRED': '請填實際付款日期和日圓實付金額，或儲存草稿。',
  'acc103.error.SYNC_REQUIRED': '請核對付款資訊並勾選同步原支出。',
  'acc103.error.PAYMENT_INVALID': '請核對付款日期、金額及版本。',
  'acc103.error.FILE_LIMIT': '檔案不能為空且不得超過10MB。',
  'acc103.error.FILE_TYPE': '非有效JPEG、PNG、WebP或PDF。',
  'acc103.error.PDF_LIMIT': 'PDF須未加密且不超過10頁。',
  'acc103.error.IMAGE_LIMIT': '圖片尺寸過大，請縮小後上傳。',
  'acc103.error.ATTACHMENT_LIMIT': '每組最多10個附件、合計20頁。',
  'acc103.error.AI_DISABLED': 'AI未啟用，請手動填寫或完成實際圖片驗收。',
  'acc103.error.CONSENT_REQUIRED': '傳送辨識前需要明確同意。',
  'acc103.error.AI_LIMIT': '訂閱額度或速率限制，請稍後手動重試。',
  'acc103.error.AI_ACCESS': '訂閱金鑰權限不足，請管理員核對。',
  'acc103.error.AI_TIMEOUT': '辨識逾時或網路異常，原件已保留，可手動重試。',
  'acc103.error.AI_FAILED': '辨識失敗，原件已保留，可手動填寫或重試。',
  'acc103.error.AI_INVALID': '結果格式不正確或不完整，請人工核對後重試。',
  'acc103.error.INTERRUPTED': '上次辨識中斷，未自動重試，請核對後重試。',
  'acc103.expenseName': '費用名稱',
  'menu.accounting.expense-invoices': '費用發票管理',
};
